import { useId } from 'vue'

import type { JWT } from '@/types/Common'
import type { User } from '@/types/User.ts'

export const parseJwt = (token: string): JWT | null => {
    if (!token) return null

    const splitToken = token.split('.')
    if (splitToken.length !== 3) return null

    return JSON.parse(atob(token.split('.')[1]))
}

export const generateRandomId = (prefix = ''): string => {
    prefix = prefix ? `${prefix}-` : ''
    return `${prefix}${useId()}`
}

export const objectKeys = <T extends object>(obj: T) => {
    return Object.keys(obj) as (keyof T)[]
}

export const $prettyNumberRounding = (val: number | string, numOfDecimals = 2) => {
    if (!numOfDecimals || numOfDecimals < 2) {
        numOfDecimals = 2
    } else if (numOfDecimals > 6) {
        numOfDecimals = 6
    }

    const numberToAdd = Math.trunc(5000 / Math.pow(10, numOfDecimals - 2))

    const num = Number(Number(val).toFixed(0))
    let numText = ''

    if (num >= 0) {
        numText = `${num + numberToAdd}`.padStart(7, '0')
    } else {
        numText = `${(num - numberToAdd) * -1}`.padStart(7, '0')
        numText = `-${numText}`
    }

    if (numText.slice(-(6 - numOfDecimals)) === '0'.repeat(6 - numOfDecimals)) {
        const lastDigit = numText.charAt(numText.length - (7 - numOfDecimals))
        switch (lastDigit) {
            case '1':
            case '3':
            case '5':
            case '7':
            case '9':
                numText = numText.slice(0, -(7 - numOfDecimals)) + String(Number(lastDigit) - 1) + numText.slice(-(6 - numOfDecimals))
        }
    }

    if (numOfDecimals < 6) {
        return `${numText.slice(0, -6)}.${numText.slice(-6, -6 + numOfDecimals)}`
    } else {
        return `${numText.slice(0, -6)}.${numText.slice(-6)}`
    }
}

export const formatNumber = (val: number | null | undefined, { decimals = 2, NAText = '0.00' } = {}) => {
    if (!val) return NAText

    const num = Number(val)
    if (isNaN(num)) return NAText

    return $prettyNumberRounding(num, decimals)
}

export const getUserNameInitials = (userData: User) => {
    if (!userData.first_name || !userData.last_name) return ''
    return (userData.first_name.charAt(0) + userData.last_name.charAt(0)).toUpperCase()
}

export const PRICE_MULTIPLIER = 1_000_000
export const nullDate = '0001-01-01'
export const MongoDBNullId = '000000000000000000000000'
